// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3GvlN","errors":"Errors_errors__1zyAI"};